"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var inertia_1 = require("@inertiajs/inertia");
var ziggy_js_1 = __importDefault(require("ziggy-js"));
var Checkbox_1 = __importDefault(require("@/Jetstream/Checkbox"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var ConversionTracking_1 = require("../functions/ConversionTracking");
var AcceptTermsModal = function () {
    var _a;
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }), t = _b.t, i18n = _b.i18n;
    var language = i18n.language;
    var _c = (0, q_play_components_1.useModal)(), isShown = _c.isShown, toggle = _c.toggle;
    var page = (0, useTypedPage_1.default)();
    var _d = react_1.default.useState({}), errors = _d[0], setErrors = _d[1];
    var form = (0, inertia_react_1.useForm)({
        companyName: (_a = page.props.session.current_account.name) !== null && _a !== void 0 ? _a : "",
        phoneNumber: "",
        acceptTermsAndConditions: false
    });
    function logout(e) {
        e.preventDefault();
        inertia_1.Inertia.post((0, ziggy_js_1.default)("logout"));
        location.reload();
    }
    (0, react_1.useEffect)(function () {
        if (page.props.session.missing_account_name_and_terms && !isShown) {
            toggle();
        }
    }, []);
    var onConfirm = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var postData, hasErrors, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    postData = {
                        companyName: form.data.companyName,
                        phoneNumber: form.data.phoneNumber,
                        acceptTerms: form.data.acceptTermsAndConditions
                    };
                    setErrors({});
                    hasErrors = false;
                    if (postData.companyName == "") {
                        setErrors(function (errors) { return (__assign(__assign({}, errors), { companyName: t("Company name is required") })); });
                        hasErrors = true;
                    }
                    if (postData.companyName.length > 100) {
                        setErrors(function (errors) { return (__assign(__assign({}, errors), { companyName: t("Company name cannot be longer than 100 characters") })); });
                        hasErrors = true;
                    }
                    if (postData.phoneNumber == "") {
                        setErrors(function (errors) { return (__assign(__assign({}, errors), { phoneNumber: t("Phone number is required") })); });
                        hasErrors = true;
                    }
                    if (!postData.acceptTerms) {
                        setErrors(function (errors) { return (__assign(__assign({}, errors), { acceptTermsAndConditions: t("Accept Terms & Conditions") })); });
                        hasErrors = true;
                    }
                    if (hasErrors) {
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.submitAccountNameAndAcceptTerms(postData)];
                case 2:
                    response = _c.sent();
                    if (response.data.errors && response.status === 422) {
                        setErrors({ companyName: (_a = response.data.errors.companyName) !== null && _a !== void 0 ? _a : undefined, phoneNumber: (_b = response.data.errors.phoneNumber) !== null && _b !== void 0 ? _b : undefined });
                    }
                    else {
                        (0, ConversionTracking_1.doTrackingRedirect)(language, "https://nordicscreen.com/signup-successful/", "https://nordicscreen.com/signup-successful-en/", page);
                        toggle();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    logger.error(error_1.message, error_1);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var body = (react_1.default.createElement("form", null,
        react_1.default.createElement("div", { className: "d-flex flex-column" },
            page.props.session.current_account.name === "" &&
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Label_1.default, { htmlFor: "account_name" }, t("Company Name")),
                    react_1.default.createElement(Input_1.default, { id: "account_name", type: "text", required: true, onChange: function (e) { form.setData("companyName", e.target.value); }, autoFocus: true }),
                    errors.companyName && react_1.default.createElement("span", { className: "w-100 text-danger small" }, errors.companyName)),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "phone_number" }, t("Phone Number")),
                react_1.default.createElement(Input_1.default, { id: "phone_number", type: "tel", className: "mt-1 block w-full", value: form.data.phoneNumber, onChange: function (e) { form.setData("phoneNumber", e.currentTarget.value); }, required: true, "data-cy": "phoneInput" }),
                errors.phoneNumber && react_1.default.createElement("span", { className: "w-100 text-danger small" }, errors.phoneNumber)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Checkbox_1.default, { name: "terms", onChange: function (e) { return form.setData("acceptTermsAndConditions", e.target.checked); }, required: true }),
                react_1.default.createElement("span", { style: { fontSize: "12px" } },
                    "\u00A0",
                    t("Accept"),
                    "\u00A0",
                    react_1.default.createElement("a", { target: "_blank", href: "https://nordicscreen.com/terms-and-conditions/", style: { color: "var(--info-color)" }, rel: "noreferrer" }, t("Terms & Conditions"))),
                react_1.default.createElement("br", null),
                errors.acceptTermsAndConditions && react_1.default.createElement("span", { className: "w-100 text-danger small" }, errors.acceptTermsAndConditions))),
        react_1.default.createElement("div", { className: "d-flex flex-fill justify-content-between", style: { marginTop: "1rem" } },
            react_1.default.createElement(q_play_components_1.Button, { onClick: logout, variant: "secondary", text: t("Sign out"), size: "small", type: "button" }),
            react_1.default.createElement(q_play_components_1.Button, { onClick: onConfirm, variant: "primary", text: t("Accept"), size: "small", className: "w-75", type: "submit" }))));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, actionRequired: true, centered: true, onClose: toggle, headerText: page.props.session.current_account.name === "" ? "".concat(t("Account information")) : "".concat(t("Terms & Conditions")), body: body }));
};
exports.default = AcceptTermsModal;
